<template>
    <div class="power">
        <Title firstName="用电统计" lastName="ELECTRICITY STATISTICS"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>本月总电量</p>
                    <p>{{monthTotal}}<span> kWh</span></p>
                </div>
                <!-- <div class="sevenDay" >近七日用电</div> -->
            </div>
            <div class="eview" v-if="$store.state.currentPage == 2">
                <Bar :chartId="chartId" :seriesData="seriesData" :xData="xData" unit="kWh" v-if="seriesData.length > 0"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../components/title/Title')
const Bar = () => import('../../components/echarts/bar.vue')
import { getMonthTime, getSevenDays } from '../../utils/common'

export default {
    data(){
        return {
            chartId:'sitePower',
            xData:['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            seriesData:[],
            monthTotal:''

        }
    },
    components:{
        Title,Bar
    },
    mounted(){
        this.getTotalElectricity()
        this.getWeekElectricity()
    },
    methods:{
        // 获取当月的项目总用电 
        async getTotalElectricity(){
            let time = getMonthTime()
            console.log(time);
            let data = {
                projectId:this.$store.state.projectId,
                start:`${time.start}T00:00:00Z`,
                end:`${time.end}T00:00:00Z`
            }
            let res = await this.$http.PowerAreasAnalysis(data)
            
            let total = res.data.data.result.find(item => item['总'])
            this.monthTotal = (total['总'].total ).toFixed(2)
            
            // let sevenDays = total['总'].year_2022
            // console.log(sevenDays);
        },
        // 获取最近7天的用电量
        async getWeekElectricity(){
            let sevenDays = getSevenDays()
            // console.log(sevenDays);

            let keys = Object.values(sevenDays)
            // console.log(keys);

            let days = []
            for(let i = 0;i <keys.length;i++){
                days.unshift(keys[i].substr(5))
            }

            let arr = []
            for(let i = 0;i<days.length;i++){
                let data = {
                    projectId:this.$store.state.projectId,
                    start:`${keys[i]}T00:00:00Z`,
                    end:`${keys[i]}T24:00:00Z`,
                }
                let res = await this.$http.diagramDay(data)
                arr.unshift(res.data.data.data[0])

            }

            this.xData = days
            this.seriesData = arr
            
        }
    }
}
</script>

<style lang="less" scoped>
    .power{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 64.4vh;
        left: 2vw;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
                .sevenDay{
                    font-size: 12rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    position: absolute;
                    right: 1vw;
                    top: 6.5vh;
                }
            }

            .eview{
                padding: 0 0.5vw;
                height: 17.9vh;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>